import { Card, CardContent } from '@zaogig/ui/card';
import { Textarea } from '@zaogig/ui/textarea';
import { Button } from '@zaogig/ui/button';
import { MapPin } from 'lucide-react';
import type { SummaryQuestionResponse } from '../../hooks/use-attendance-state';

interface CheckOutSummaryPhaseProps {
  question: SummaryQuestionResponse;
  summary: string;
  onSummaryChange: (summary: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
  location?: { lat: number; lng: number } | null;
  isSubmitting?: boolean;
}

export function CheckOutSummaryPhase({
  question,
  summary,
  onSummaryChange,
  onSubmit,
  onCancel,
  location,
  isSubmitting = false
}: CheckOutSummaryPhaseProps) {
  return (
    <div className="flex flex-col min-h-[60vh] px-6 py-4">
      <div className="mb-6">
        <h2 className="text-lg font-bold text-gray-800 mb-2">工作小结</h2>
        <p className="text-gray-500 text-sm">
          请简单总结一下今天完成的工作内容
        </p>
      </div>

      <Card className="mb-6">
        <CardContent className="p-4">
          <p className="font-medium text-gray-800">{question.question}</p>
        </CardContent>
      </Card>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          工作总结
        </label>
        <Textarea
          value={summary}
          onChange={(e) => onSummaryChange(e.target.value)}
          placeholder="请描述您今天完成了哪些工作..."
          className="min-h-[120px] resize-none"
          disabled={isSubmitting}
        />
      </div>

      {location && (
        <div className="mb-6 flex items-center gap-2 text-sm text-gray-500">
          <MapPin className="w-4 h-4" />
          <span>位置已获取</span>
        </div>
      )}

      <div className="mt-auto space-y-3">
        <Button
          onClick={onSubmit}
          className="w-full bg-orange-600 hover:bg-orange-700"
          disabled={!summary.trim() || isSubmitting}
        >
          {isSubmitting ? '提交中...' : '提交并下班'}
        </Button>
        <Button
          variant="outline"
          onClick={onCancel}
          className="w-full"
          disabled={isSubmitting}
        >
          继续工作
        </Button>
      </div>
    </div>
  );
}
